function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.09,
    width: 16,
    height: 16,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.99,8.46l1.98,1.33c.06.04.12.09.18.16.06.06.1.14.1.23v.75c0,.05-.02.1-.05.13-.04.04-.08.05-.13.05-.01,0-.02,0-.04,0-.01,0-.03-.01-.06-.02l-3.07-2.07c-.08-.05-.14-.1-.19-.15s-.07-.12-.07-.21v-.37c0-.09.02-.16.07-.21.04-.05.11-.1.19-.15l3.07-2.07s.04-.02.06-.02c.01,0,.03,0,.04,0,.05,0,.1.02.13.05.03.04.05.08.05.13v.75c0,.09-.03.16-.1.23s-.13.12-.18.16l-1.98,1.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94,4.9c.03-.06.07-.12.13-.18.06-.06.14-.08.25-.08h.65c.05,0,.1.02.14.06.04.04.06.08.06.14,0,.02,0,.05-.02.08l-2.96,7.09c-.02.06-.06.12-.12.18s-.15.09-.26.09h-.62c-.05,0-.1-.02-.14-.06s-.06-.08-.06-.14c0-.02,0-.05.02-.08l2.94-7.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.18,7.12c-.06-.04-.12-.09-.18-.16-.06-.06-.1-.14-.1-.23v-.75c0-.05.02-.1.05-.13.04-.04.08-.05.13-.05.01,0,.02,0,.04,0s.03.01.06.02l3.07,2.07c.08.05.14.1.19.15.04.05.07.12.07.21v.37c0,.09-.02.17-.07.21s-.11.1-.19.15l-3.07,2.07s-.04.02-.06.02c-.01,0-.03,0-.04,0-.05,0-.1-.02-.13-.05-.03-.04-.05-.08-.05-.13v-.75c0-.09.03-.16.1-.23s.13-.12.18-.16l1.98-1.33-1.98-1.33Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDefault);
export default __webpack_public_path__ + "static/media/logo-default.a38d105fc03bb632fc051aeec3baf879.svg";
export { ForwardRef as ReactComponent };